<div class="c-form__item u-width-100">
  <label [for]="identifier" class="checkbox u-margin-0">
    <input
      type="checkbox"
      class="checkbox__input"
      [(ngModel)]="value"
      id="{{ identifier }}"
      [disabled]="disabled ? true : null"
    />
    <span class="checkbox__indicator"
      ><i class="fa fa-check" aria-hidden="true"></i
    ></span>
    <div class="checkbox__label">
      {{ title | lsTranslate }}
      <p *ngIf="description">{{ description | lsTranslate }}</p>
    </div>
  </label>
  <div class="c-form__message"></div>
  <div
    class="wrapper"
    *ngIf="wrapped"
    (click)="handleWrapperClick($event); (false)"
  ></div>
</div>
